<template>
    <div class="adv">
      <img src="../../static/img/ad.png" alt="">
    </div>
</template>

<script>
    export default {
        name: "ad",
        data(){
            return {
                msg: "Hello Vue.js"
            }
        },
        component: {
            //someComponent
        }
    }
</script>

<style scoped lang="less">
  .adv{
    height:1.3rem;
    width:100%;
      img{
        width:100%;
        height:100%;
      }
  }

</style>



// WEBPACK FOOTER //
// src/components/advertisement.vue